import { dreMock } from './mock/dreMock';

export const dreApi = {
  // FIXME: utilizar endpoint
  // get: () => axios.get(`${PATH}`),
  get: () => dreMock.get(),
};
